if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.isCartContext = this.dataset.cartContext === 'true';

      if (this.input) {
        this.input.addEventListener('change', this.onInputChange.bind(this));
      }

      this.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }

    connectedCallback() {
      this.validateQtyRules();
    }

    onInputChange(event) {
      this.validateQtyRules();
      this.updateDisplay();
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      // Ensure we act on the actual button, not inner elements
      const button = event.currentTarget || event.target.closest('button');
      const action = button?.name;

      if (action === 'plus') {
        if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
          this.input.value = this.input.dataset.min;
        } else {
          this.input.stepUp();
        }
      } else if (action === 'minus') {
        this.input.stepDown();
      }

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }

      if (this.input.dataset.min === previousValue && action === 'minus') {
        this.input.value = parseInt(this.input.min);
      }

      this.updateDisplay();
      this.validateQtyRules();
    }

    updateDisplay() {
      const sectionId = this.dataset.section;
      const displayElement = document.getElementById(`QuantityDisplayValue-${sectionId}`);
      const quantityTextContainer = document.getElementById(`QuantityText-${sectionId}`);
      const pluralTextElement = quantityTextContainer
        ? quantityTextContainer.querySelector('[data-single][data-multiple]')
        : null;

      if (displayElement) {
        const currentQuantity = this.input.value;
        displayElement.textContent = currentQuantity;

        // Update aria-label for screen readers
        displayElement.setAttribute('aria-label', `Current quantity: ${currentQuantity}`);

        // Update Pair/Pairs text based on quantity
        if (pluralTextElement) {
          const quantity = parseInt(currentQuantity, 10);
          pluralTextElement.textContent =
            quantity > 1
              ? pluralTextElement.getAttribute('data-multiple')
              : pluralTextElement.getAttribute('data-single');
        }
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);

      if (this.input.min) {
        const buttonMinus = this.querySelector("button[name='minus']");
        if (buttonMinus) {
          const isDisabled = value <= parseInt(this.input.min);
          buttonMinus.classList.toggle('disabled', isDisabled);
          buttonMinus.setAttribute('aria-disabled', isDisabled.toString());
        }
      }

      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector("button[name='plus']");
        if (buttonPlus) {
          const isDisabled = value >= max;
          buttonPlus.classList.toggle('disabled', isDisabled);
          buttonPlus.setAttribute('aria-disabled', isDisabled.toString());
        }
      }
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
